import { useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connectToHubLogs } from "src/redux/slices/hub";
import buildHubUrl from "./buildHubUrl";
import CreateConnection from "./HubMatrix";
import { setHaveErrorLogs } from "src/redux/slices/logs";

export default function useHubLogs() {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.authJwt);
  const isConnectedRef = useRef(false); // Para evitar múltiples conexiones

  // Función optimizada para manejar errores en logs
  const handleLogError = useCallback(() => {
    dispatch(setHaveErrorLogs(true));
  }, [dispatch]);

  useEffect(() => {
    if (!user?.id || isConnectedRef.current) return;

    isConnectedRef.current = true; // Evita conexiones repetidas

    const cleanup = CreateConnection(
      buildHubUrl("/hub/logs", { restauranteId: user.id }),
      [
        {
          id: `${user.id}`,
          operator: handleLogError,
        },
      ],
      dispatch,
      connectToHubLogs,
      "logs"
    );

    return () => {
      cleanup(); // Asegura que la conexión se cierra al desmontar
      isConnectedRef.current = false;
    };
    // Antes era `[]` — bug latente: si el componente montaba antes de
    // que `user` estuviese en Redux (login fresco), el efecto bailaba
    // y `[]` nunca lo volvía a disparar → la conexión a hub/logs no
    // se abría. Con `[user?.id]` reacciona en cuanto llega el user.
  }, [user?.id, handleLogError, dispatch]);
}
